<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a school drop down
    *
    * @since 20210810
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2021 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <div>
        <label v-if="!hide_label">{{school_name.name}}</label>
        <span v-if="multi_select">
            <v-multiselect v-if="schools_actual.length > 0" ref="multiSelect"
                :label="!hide_label ? school_name.name : ''"
                :multiple="true"
                :placeholder="default_select.length == 0 ? 'Please select a ' + school_name.name : default_select" 
                :select-options='schools_actual'                                  
                :value="school_data"
                v-on:input="update_school_multi($event)"
            ></v-multiselect> 
            <span v-else>Loading Data</span>
        </span>
        <select v-else class="form-control" :name="name" :value="school_data" :key="schools_actual.length + '_' + school_data" v-on:input="update_school($event)" >
            <option v-if="default_select.length == 0" :value="default_select_value">Please select a {{school_name.name}}</option>
            <option v-else :value="default_select_value">{{default_select}}</option>
            <option v-for="sch in schools_actual" :key="sch.id" :value="sch.id">{{sch.name}}</option>
            <option v-if="(!hasLoaded || loading) && school_data != 0" :value="school_data">Loading Selected Option</option>
            <option v-if="!hasLoaded || loading" value="-2">Loading extra options...</option>
            <option v-if="!showAll && schools_actual.length >=100" value="-3">Click to load full list</option>
        </select>
    </div>
</template>

<script>
    import loadcomponents from './loadcomponents'
    export default {
        props: {
            //the name of the input
            name: {
                type: String,
                default: 'school_id'
            },
            //the schools
            schools: {
                type: Array,
            },
            //the width
            width: {
                default: ''
            },
            //the name of schools
            school_name: {
                default: Object
            },
            //the defalt value
            value: {
                default: 0
            },
            //the defalt value
            default_select: {
                default: ''
            },
            //the defalt value
            default_select_value: {
                default: 0
            },
            //whether or not to hide the label
            hide_label: {
                default: false
            },
            loadasyncroute: {
                type: String,
                default: ''
            },
            user_website_id: {
                type: String,
                default: '0_0'
            },
            refresh_data: {
                type: Boolean,
                default: false
            },
            multi_select: {
                type: Boolean,
                default: false
            },
            emit_array: {
                type: Boolean,
                default: false
            }
        },
        created(){
            this.school_data = this.value;
            if(this.school_data == ''){
                this.school_data = 0;
            }
            this.$searchSchoolId = this.school_data;
            
        },
        mounted(){
            if(this.loadasyncroute.length > 0){
                this.getData();
            } else {
                this.hasLoaded = true;
            }
        },
        data() {
            return {
                school_data: 0,
                schools_all: this.schools,
                hasLoaded: false,
                loading: false,
                showAll: false
            };
        },
        asyncComputed: {
            /**
             * returns current list of jobs
             * 
             * @return Array the list
             */
            schools_actual: {
                get() {
                    return loadcomponents.doThread(function({data}) {
                        if(data.academic_year == 0){
                            var arr = [];
                            for(var i=0; i<data.schools.length; i++){
                                if(data.showAll || arr.length < 100 || data.schools[i].id == data.school_data){
                                    arr.push(data.schools[i]);
                                }
                            }
                            return self.postMessage(arr);
                        } else {
                            var arr = [];
                            try
                            {
                                for(var i=0; i<data.schools.length; i++){
                                    if(data.showAll || arr.length < 100 || data.schools[i].id == data.school_data){
                                        if(data.schools[i].academic_years.length == 0 || data.schools[i].academic_years == 0){
                                            arr.push(data.schools[i]);
                                        } else {
                                            var years = (data.schools[i].academic_years + '').split(',');
                                            
                                            for(var k=0; k<years.length; k++){
                                                if(years[k] == data.academic_year){
                                                    arr.push(data.schools[i]);
                                                    k = years.length;
                                                }
                                            }
                                        }
                                    }
                                }
                            } catch(error) {
                                console.log('An error updating the schools actual in the school drop');
                                if(error.response !== undefined){
                                    console.log('File: ' + error.response.data.file);
                                    console.log('Line: ' + error.response.data.line);
                                    console.log('Message: ' + error.response.data.message);
                                    console.log('Exception: ' + error.response.data.exception);
                                    console.log(error.response.data.trace);
                                } else {
                                    console.log(error);
                                }
                            }
                            return self.postMessage(arr);
                        }
                    }, {schools: this.schools_all, showAll: this.showAll, school_data: this.school_data, academic_year: this.academic_year});
                },
                default: []
            }
        },
        computed: {
            academic_year: function(){
                if(this.$searchAcademicYearId > 0 || this.$searchDateAcademicYearId < 0){
                    return this.$searchAcademicYearId + '';
                } else {
                    return this.$searchDateAcademicYearId + '';
                }
            }
        },
        methods: {
            /**
            * gets the data for the tab
            */
            getData: async function (refresh = false) {
                if((!this.hasLoaded || refresh) && !this.loading && this.loadasyncroute.length > 0){
                    refresh = refresh || this.refresh_data;
                    this.loading = true;
                    if(refresh){
                        this.hasLoaded = false;
                    }
                    var parsedData = null;
                    try {
                        var existingData = localStorage.getItem("school_drop_" + this.user_website_id);
                        if(existingData !== null && existingData !== undefined){
                            parsedData = JSON.parse(existingData);
                            if(!Array.isArray(parsedData)){
                                parsedData = null;
                            } else if(parsedData.length > 0 && parsedData[0].academicYear === undefined){
                                parsedData = null;
                            }
                        }
                    } catch(error) {
                        parsedData = null;
                        console.log('An error occurred getting the local data');
                        if(error.response !== undefined){
                            console.log('File: ' + error.response.data.file);
                            console.log('Line: ' + error.response.data.line);
                            console.log('Message: ' + error.response.data.message);
                            console.log('Exception: ' + error.response.data.exception);
                            console.log(error.response.data.trace);
                        } else {
                            console.log(error);
                        }
                    }
                    try {
                        if(parsedData !== null && !refresh){
                            this.schools_all = parsedData;
                            this.hasLoaded = true;
                        } else {
                            const { data } = await this.$http.get(this.loadasyncroute);
                            
                            if(data.error !== undefined){
                                console.log('An error occurred getting the data');
                                console.log(data.error);
                            } else if(data !== undefined){
                                this.schools_all = data;
                                localStorage.setItem("school_drop_" + this.user_website_id, JSON.stringify(this.schools_all));
                                this.hasLoaded = true;
                            } else {
                                console.log(data);
                            }
                        }
                    } catch(error) {
                        console.log('An error occurred getting the data');
                        if(error.response !== undefined){
                            console.log('File: ' + error.response.data.file);
                            console.log('Line: ' + error.response.data.line);
                            console.log('Message: ' + error.response.data.message);
                            console.log('Exception: ' + error.response.data.exception);
                            console.log(error.response.data.trace);
                        } else {
                            console.log(error);
                        }
                    }
                    this.loading = false;
                }
            },
            /**
             * updates the model of the editor to the current value
             * @param String value the value of the editor
             */
            update_school_multi: function (value) {
                var schoolIds = '';
                var comma = '';
                for(var i=0; i<value.length; i++){
                    schoolIds += comma + value[i].id + '';
                    comma = ',';
                }
                if(this.emit_array){
                    this.$emit('input', value);
                } else {
                    this.$emit('input', schoolIds);
                }
                this.school_data = value;
            },
            /**
             * updates the model of the editor to the current value
             * @param String value the value of the editor
             */
            update_school: function (value) {
                var newValue = 0;
                if(value.target !== undefined){
                    newValue = value.target.value;
                } else {
                    newValue = value;
                }
                if(newValue == -3){
                    this.showAll = true;
                    newValue = this.school_data;
                } else if(newValue == -2){
                    newValue = this.school_data;
                }
                this.school_data = newValue;
                this.$emit('input', this.school_data);
            },
        },
        watch: {
            /**
             * Handle changes to school
             */
            school_data: function() {
                if(this.school_data !== undefined && this.school_data !== null && this.school_data.constructor === Array){
                    var schoolIds = '';
                    var comma = '';
                    for(var i=0; i<this.school_data.length; i++){
                        schoolIds += comma + this.school_data[i].id + '';
                        comma = ',';
                    }
                    this.$searchSchoolId = schoolIds;
                } else {
                    this.$searchSchoolId = this.school_data;
                }
            },
        }
    }
</script>
